import { render, staticRenderFns } from "./BgImageLayout.vue?vue&type=template&id=2bf2d122&scoped=true&"
import script from "./BgImageLayout.vue?vue&type=script&lang=js&"
export * from "./BgImageLayout.vue?vue&type=script&lang=js&"
import style0 from "./BgImageLayout.vue?vue&type=style&index=0&id=2bf2d122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2d122",
  null
  
)

export default component.exports